import React from "react";
import { Badge, ListItemButton as ListItemButtonBase, ListItemText } from "@mui/material";

// MUI v5 replaced `<ListItem button>` with `<ListItemButton>`. Alias it (cast to
// `any`) so the polymorphic `component`/router props below still type-check.
const ListItem: any = ListItemButtonBase;
import { makeStyles } from "@/compat/muiStyles";
import NavLinkWrapper from "./NavLinkWrapper";

const useStyles = makeStyles((theme) => ({
    container: (props) => ({
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1),
        paddingLeft: theme.spacing(6),
        paddingRight: theme.spacing(3),
        fontWeight: theme.typography.fontWeightRegular,

        alignItems: "center",
        "&:hover": {
            background: "#F4EEFF",
            borderRadius: "8px",
        },
        [`&.${props.activeClassName}`]: {
            background: "#F4EEFF",
            borderRadius: "8px",
        },
    }),
    label: {
        margin: 0,
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),

    },
    labelText: (props) => ({
        color: "#48464A",
        fontWeight: "500",
        [`.${props.activeClassName} &`]: {
            color: "#483795",
            fontWeight: "600",
        }
    }),

    badge: {
        marginLeft: "auto",
    },
    icon: {
        color: "#48464A"
    },
}));

function PlatformSidebarLink({ name, to, badge = null, icon: Icon }) {
    const activeClassName = "active";
    const classes = useStyles({ activeClassName });

    return (
        <ListItem
            dense
            component={NavLinkWrapper}
            exact
            to={to}
            activeClassName={activeClassName}
            className={classes.container}
        >
            {Icon && <Icon className={classes.icon} />}
            <ListItemText className={classes.label} classes={{ primary: classes.labelText }}>{name}</ListItemText>
            {badge && (
                <Badge className={classes.badge} color="error" badgeContent={badge} />
            )}
        </ListItem>
    );
}

export default PlatformSidebarLink;
